import React, { forwardRef } from "react";
import { BaseTextField } from "./BaseTextField";
import { useTheme } from "@emotion/react";
import styles from "./NewTextField.module.scss";
const NewTextFieldFC = (props, ref) => {
    const theme = useTheme();
    return (React.createElement(BaseTextField, Object.assign({}, props, { ref: ref, suffix: React.createElement("div", { className: styles.SuffixDiv },
            props.suffixIcon1 && (React.createElement(props.suffixIcon1, { onClick: props.suffixIcon1OnClick, size: 24, color: theme.colors.dark["300"] })),
            props.suffixIcon2 && (React.createElement(props.suffixIcon2, { size: 24, onClick: props.suffixIcon2OnClick, color: theme.colors.dark["300"] }))) })));
};
export const NewTextField = forwardRef(NewTextFieldFC);
//# sourceMappingURL=NewTextField.js.map